import { get, post, put, remove } from "../helpers/apiHelper";
import { Api } from "../constants";
import { Category, CategoriesFetchResponse } from "../types";
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from "../utils/constants";

export const getAllCategories = async (): Promise<CategoriesFetchResponse> => {
  const result = await get<Category[]>(Api.categories);

  if (Array.isArray(result)) {
    return {
      status: "SUCCESS",
      statusCode: 200,
      message: SUCCESS_MESSAGES.FETCH_ALL_CATEGORIES_SUCCESS,
      data: result,
    } as CategoriesFetchResponse;
  }

  if (
    result &&
    typeof result === "object" &&
    !Array.isArray(result) &&
    "status" in result
  ) {
    const errorResult = result as { status: string; message?: string; statusCode?: number };
    if (errorResult.status === "ERROR") {
      const errorMessage =
        errorResult.message || ERROR_MESSAGES.FAILED_TO_FETCH_ITEMS_CATEGORIES;
      const error = new Error(errorMessage) as any;
      error.response = {
        data: {
          status: errorResult.status,
          statusCode: errorResult.statusCode || 500,
          message: errorMessage,
        },
      };
      throw error;
    }
  }

  const errorMessage = ERROR_MESSAGES.FAILED_TO_FETCH_ITEMS_CATEGORIES;
  const error = new Error(errorMessage) as any;
  error.response = {
    data: {
      status: "ERROR",
      statusCode: 500,
      message: errorMessage,
    },
  };
  throw error;
};

export const createCategory = async (categoryName: string) => {
  const url = Api.createCategory;
  const payload = {
    categoryName,
  };
  const response = await post(url, payload);
  return response;
};

export const updateCategory = async (
  categoryId: string,
  categoryName: string
) => {
  const url = `${Api.updateCategory}/${categoryId}?name=${encodeURIComponent(
    categoryName
  )}`;
  const response = await put(url);
  return response;
};

export const deleteCategory = async (categoryId: string) => {
  const url = `${Api.createCategory}/${categoryId}`;
  return await remove(url);
};

export const searchCategories = async (keyword: string): Promise<CategoriesFetchResponse> => {
  const url = `${Api.searchCategories}?keyword=${encodeURIComponent(keyword)}`;
  const result = await get<Category[]>(url);

  if (Array.isArray(result)) {
    return {
      status: "SUCCESS",
      statusCode: 200,
      message: "search category success",
      data: result,
    } as CategoriesFetchResponse;
  }

  if (
    result &&
    typeof result === "object" &&
    !Array.isArray(result) &&
    "status" in result
  ) {
    return result as CategoriesFetchResponse;
  }

  throw new Error("Failed to search categories");
};
